import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap'
import { connect } from 'react-redux'

import NavHeader from './navheader'
import SubMenu from './submenu'
import Footer from './footer'

import { } from '../actions'
import { } from '../utils'

class RegisterSuccessfulPage extends Component {

    componentDidMount(){
        window.fbq('trackCustom', 'Step5View')
    }

    render() {
        return (
            <div>
                <NavHeader history={this.props.history} />
                <SubMenu ref={d => this.submenu = d} history={this.props.history} />
                <div className="container main-bg">
                    <Row>
                        <Col xs={1} sm={4} md={4}>
                        </Col>
                        <Col xs={10} sm={4} md={4}>
                            <img src="../../static/images/logo_songsod_blue.png" style={{ width: '100%', marginBottom: 20, marginTop: 60 }} />
                            <h4 style={{ textAlign: 'center' }}>ขอขอบคุณที่วางใจใช้บริการส่งสดค่ะ</h4>
                            <h3 style={{ color: '#f57224 !important', marginBottom:20, textAlign:'center' }}>"สมัครสมาชิกเสร็จเรียบร้อย"</h3>
                            <Row>
                                <Col xs={12} sm={12} md={12}><button className='btn btn-primary pull-right' style={{ width: '100%', marginBottom: 70 }} onClick={() => { this.props.history.push('/login') }}>เข้าสู่ระบบ</button></Col>
                            </Row>
                        </Col>
                        <Col xs={1} sm={4} md={4}>
                        </Col>
                    </Row>
                </div>
                <Footer history={this.props.history} />
            </div>
        )
    }

}

// function mapStateToProps(state) {
//     return {
//         delivery_time: state.delivery_time_reducer
//     }
// }

export default connect(null, {})(RegisterSuccessfulPage)


// WEBPACK FOOTER //
// ./src/components/page_register_successful.js